import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../utils/httpCommon";

const responseInitialState = {
    message: '',
    title: 'Ha ocurrido un error',
    status: 'error'
}

const initialState = {
    loading: false,
    error: '',
    response: responseInitialState,
    fetchInitialData: {
        bank: [{ code: '', name: '' }]
    }
}

export const verifyPayment = createAsyncThunk('payment/verify', async (payment: PaymentForm) => {

    const response = await http.post('/payment/verify', {
        ...payment,
        amount: parseFloat(payment.amount.toString())
    })
        .then((response: any) => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error.response.data.message)
        })

    return response
})

export const fetchPaymentData = createAsyncThunk('payment/initial/data', async () => {

    return await http.get('/bank')
        .then((response: any) => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error.response.data.message)
        })
})

const paymentSlice = createSlice({
    name: 'verifyPayment',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(verifyPayment.pending, (state, action) => {
                state.loading = true
                state.error = ''
                state.response = responseInitialState
            })
            .addCase(verifyPayment.fulfilled, (state, action) => {

                state.loading = false

                if (!action.payload.success)
                    state.error = action.payload.message
                else {
                    state.response.message = action.payload.object.messages
                    state.response.title = action.payload.object.title
                    state.response.status = action.payload.object.status
                }

            })
            .addCase(verifyPayment.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message!.toString()
            })

        builder
            .addCase(fetchPaymentData.pending, (state, action) => {
                state.loading = true
                state.error = ''
                state.response = responseInitialState
            })
            .addCase(fetchPaymentData.fulfilled, (state, action) => {
                state.loading = false
                state.fetchInitialData = action.payload
            })
            .addCase(fetchPaymentData.rejected, (state, action) => {
                state.loading = false
            })
    }
})

export default paymentSlice.reducer;